import { useEffect, useState } from "react";
import API from "../services/api";

export default function Transport() {
  const [routes, setRoutes] = useState([]);

  const [form, setForm] = useState({
    route_name: "",
    pickup_point: "",
    monthly_fee: "",
    driver_name: "",
    driver_phone: ""
  });

  const fetchRoutes = async () => {
    try {
      const res = await API.get("/transport/routes");
      setRoutes(res.data);
    } catch (err) {
      alert("Unable to fetch transport routes");
    }
  };

  useEffect(() => {
    fetchRoutes();
  }, []);

  const handleAddRoute = async () => {
    try {
      await API.post("/transport/add-route", form);

      alert("Transport route added successfully");

      setForm({
        route_name: "",
        pickup_point: "",
        monthly_fee: "",
        driver_name: "",
        driver_phone: ""
      });

      fetchRoutes();

    } catch (err) {
      alert("Failed to add transport route");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Transport Management
      </h1>

      <div className="bg-white shadow p-6 rounded mb-6">

        <input
          placeholder="Route Name"
          value={form.route_name}
          onChange={(e) =>
            setForm({ ...form, route_name: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Pickup Point"
          value={form.pickup_point}
          onChange={(e) =>
            setForm({ ...form, pickup_point: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Monthly Fee"
          value={form.monthly_fee}
          onChange={(e) =>
            setForm({ ...form, monthly_fee: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Driver Name"
          value={form.driver_name}
          onChange={(e) =>
            setForm({ ...form, driver_name: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <input
          placeholder="Driver Phone"
          value={form.driver_phone}
          onChange={(e) =>
            setForm({ ...form, driver_phone: e.target.value })
          }
          className="border p-2 mb-3 w-full"
        />

        <button
          onClick={handleAddRoute}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Add Route
        </button>

      </div>

      <div className="bg-white shadow p-6 rounded">
        <table className="w-full border">
          <thead>
            <tr className="bg-gray-100">
              <th>Route</th>
              <th>Pickup Point</th>
              <th>Monthly Fee</th>
              <th>Driver</th>
              <th>Phone</th>
            </tr>
          </thead>

          <tbody>
            {routes.map((route) => (
              <tr key={route.id}>
                <td>{route.route_name}</td>
                <td>{route.pickup_point}</td>
                <td>₹{route.monthly_fee}</td>
                <td>{route.driver_name}</td>
                <td>{route.driver_phone}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}